module.exports = __webpack_public_path__ + "img/Feature-7.8368d6d.svg";